export default "__VITE_ASSET__BvVFLIsX__"